// extracted by mini-css-extract-plugin
export default {"wrapper":"groups_wrapper__GjDLy","upload":"groups_upload__2OoAW","dndArea":"groups_dndArea__B6t+z","fileInfo":"groups_fileInfo__v0hFP"};